import {TimelineConnector, TimelineContent, TimelineDot, TimelineSeparator} from "@mui/lab";
import {CardContent, Grid, Typography } from "@mui/material";
import React from "react";
import {ActivityStatusStory} from "../../../../types/activity/activityData";
import {dateFormatter} from "../../../../utils/formatters";
import {getActivityStatusColor} from "../../../../utils/colors/activityColors";


interface SolicitationTaskStatusTimelineItemProps {
    entity: ActivityStatusStory
}


const SolicitationTaskStatusTimelineItem = ({entity}: SolicitationTaskStatusTimelineItemProps) => {
    const colorStatus : string = getActivityStatusColor(entity.tinCodActividadEstado);

    const styleTimelineDot = {
        backgroundColor: colorStatus,
        borderColor: colorStatus
    };

    return (
        <React.Fragment>
            <TimelineSeparator>
                <TimelineDot style={styleTimelineDot} />
                <TimelineConnector />
            </TimelineSeparator>

            <TimelineContent>
                <Typography component="div" sx={{
                    marginTop: "-2px",
                    marginBottom: "-10px"
                }}>
                    <Grid container>
                        <Grid item xs={6} style={{ color: colorStatus }}>
                            <span style={{
                                fontWeight: 400,
                                fontSize: ".928571rem"
                            }}>
                                {entity.vchDescActividadEstado}
                            </span>
                        </Grid>
                        <Grid item xs={6} sx={{
                            textAlign: 'right',
                            fontStyle: 'italic'
                        }}>
                            <Typography variant="body2" color="textSecondary" component="p">
                                {dateFormatter.toShortDate(entity.dtmFechaEstado)}
                            </Typography>
                        </Grid>
                    </Grid>
                </Typography>
                <CardContent>
                    <Typography component="p">
                        {entity.vchDescUsuarioEstado} comentó:
                    </Typography>
                    <Typography variant="body2" color="textSecondary" component="p" sx={{paddingLeft: '15px'}}>
                        {entity.vchObservacionEstado}
                    </Typography>
                </CardContent>
            </TimelineContent>
        </React.Fragment>
    )
}


export default SolicitationTaskStatusTimelineItem